/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { OverlayRef, OverlaySizeConfig } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportDisplayOverlayRef {

    constructor(private overlayRef: OverlayRef) {}

    close() {
        this.overlayRef.dispose();
    }

    getConfig() {
        return this.overlayRef.getConfig();
    }

    // wrap overlayRef methods and properties
    updateSize(sizeConfig: OverlaySizeConfig) {
        return this.overlayRef.updateSize(sizeConfig);
    }

    updatePosition() {
        return this.overlayRef.updatePosition();
    }

    get hostElement() {
        return this.overlayRef.hostElement;
    }
}
